import React, { useState } from 'react';
import { Divider, Typography, Button } from '@material-ui/core';
import { RequestAdjustModal } from './RequestAdjustModal';
import { ErrorAPI } from '@shared/components/ui/ErrorAPI';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { Loading } from '@shared/components/ui/Loading';
import { ActivityTypeSelect } from '@shared/components/forms/ActivityTypeSelect';
import { TimezoneSelect } from '@shared/components/forms/TimezoneSelect';
import { useStatsUser } from '../hooks/useSummaryQueries';
import { useStyles } from '../styles/Stats.styles';
import Auth from '@shared/services/Auth';
import { getUserTimezone } from '@shared/utils/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const Stats = (props) => {
  const classes = useStyles();
  const { date, reload, setReload, user } = props;
  const [activityTypeId, setActivityTypeId] = useState('');
  const [timezoneId, setTimezoneId] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const userTimezone = getUserTimezone();

  const { data, isLoading, isError } = useStatsUser(
    user.id,
    dayjs.tz(date, userTimezone).unix(),
    activityTypeId,
    timezoneId
  );

  const handleActivityTypeId = (event) => {
    setActivityTypeId(event.target.value);
  };

  const handleTimezoneId = (event) => {
    setTimezoneId(event.target.value);
  };

  const handleOpenModal = (event) => {
    setOpenModal(true);
  };

  const handleCloseModal = (event) => {
    setOpenModal(false);
  };

  return (
    <div className={classes.column}>
      <Typography variant="h5" className={classes.margin}>
        Résumé d'activité
      </Typography>
      {isLoading ? (
        <Loading />
      ) : isError ? (
        <ErrorAPI
          errorAPI={true}
          setErrorAPI={() => {}}
          message={
            'Un problème est survenu lors du chargement des données, veuillez recharger la page ou réessayer plus tard.'
          }
        />
      ) : data ? (
        <>
          <div className={classes.rowSpace}>
            <div className={classes.input}>
              <ActivityTypeSelect
                typeId={activityTypeId}
                handleActivityTypeId={handleActivityTypeId}
                option={'all'}
              />
              <div className={classes.button}></div>
              <TimezoneSelect timezoneId={timezoneId} handleTimezoneId={handleTimezoneId} option={'all'} />
            </div>

            {Auth.isSuperSwitchman() && (
              <Button variant="contained" color="secondary" className={classes.button} onClick={handleOpenModal}>
                Ajustement requêtes
              </Button>
            )}
          </div>
          <Typography variant="h6" className={classes.margin}>
            Totaux de la journée
          </Typography>
          <div className={classes.rowSpace}>
            <Typography variant="subtitle1">Heures d'activité</Typography>
            <Typography variant="subtitle1">{data.durationDay}</Typography>
          </div>
          <div className={classes.rowSpace}>
            <Typography variant="subtitle1">Requêtes traitées</Typography>
            <Typography variant="subtitle1">{data.daily_inquiries_number}</Typography>
          </div>
          <Divider className={classes.divider} />
          <Typography variant="h6" className={classes.margin}>
            Totaux du mois
          </Typography>
          <div className={classes.rowSpace}>
            <Typography variant="subtitle1">Heures d'activité</Typography>
            <Typography variant="subtitle1">{data.durationMonth}</Typography>
          </div>
          <div className={classes.rowSpace}>
            <Typography variant="subtitle1">Requêtes traitées</Typography>
            <Typography variant="subtitle1">{data.monthly_inquiries_number}</Typography>
          </div>
          <div className={classes.rowCenter}>
            <div className={classes.columnCenter}>
              <Typography variant="h6">En semaine</Typography>
              <div className={classes.rowSpace}>
                <Typography variant="subtitle1">Heures</Typography>
                <Typography variant="subtitle1">{data.durationMonthWeeks}</Typography>
              </div>
              <div className={classes.rowSpace}>
                <Typography variant="subtitle1">Requêtes</Typography>
                <Typography variant="subtitle1">{data.weekdays_inquiries_number}</Typography>
              </div>
            </div>
            <Divider orientation="vertical" className={classes.vertical} flexItem />
            <div className={classes.columnCenter}>
              <Typography variant="h6">En weekend</Typography>
              <div className={classes.rowSpace}>
                <Typography variant="subtitle1">Heures</Typography>
                <Typography variant="subtitle1">{data.durationMonthWeekends}</Typography>
              </div>
              <div className={classes.rowSpace}>
                <Typography variant="subtitle1">Requêtes</Typography>
                <Typography variant="subtitle1">{data.weekends_inquiries_number}</Typography>
              </div>
            </div>
          </div>
          <RequestAdjustModal
            openModal={openModal}
            handleCloseModal={handleCloseModal}
            date={date}
            requestNb={data.daily_inquiries_treated}
            reload={reload}
            setReload={setReload}
            selectedUser={user}
          />
        </>
      ) : null}
    </div>
  );
};
